import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const TermDefinition = ({ id, title, definition }) => (
  <li className={styles.termDefinition} data-search={title.toLowerCase()}>
    <h3 id={id}>{title}</h3>
    <p dangerouslySetInnerHTML={{ __html: definition }} />
  </li>
);

TermDefinition.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired
};

export default TermDefinition;
